<template>
  <v-app>
    <IE v-if="ie()" />
    <StoreHasEcommerceFeatureEnabled v-else />
  </v-app>
</template>

<script>
import { detect } from "detect-browser";
import IE from "@/views/IE.vue";
import StoreHasEcommerceFeatureEnabled from "@/components/Store/HasEcommerceFeatureEnabled.vue";

export default {
  name: "App",
  components: {
    IE,
    StoreHasEcommerceFeatureEnabled,
  },
  created() {
    this.$store.dispatch("store/fetch");
  },
  watch:{
    "$store.state.store.info.store_info.customization.website.style": function (style) {
      this.$vuetify.theme.themes.light.primary = style.primary_color;
      this.$vuetify.theme.themes.light.secondary = style.secondary_color;
      this.$vuetify.theme.themes.light.background = style.background_color;
    }
  },
  methods: {
    ie() {
      const browser = detect();
      return browser.name === "ie";
    },
  },
};
</script>
